// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "Team" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { Role } from "./role.enum.gen";
import { TeamPlanType } from "./team-plan-type.enum.gen";
import { ThemeGenShape } from "./theme.gen";
import { OidcSsoConfigGenShape } from "./oidc-sso-config.gen";

export const TeamGenShape = z.strictObject({
  name: z.string(),
  logoImage: z.string().optional(),
  fullName: z.string(),
  serviceName: z.string().optional(),
  domain: z.string().optional(),
  headerImage: z.string().optional(),
  roles: z.array(z.enum(Role)).optional(),
  additionalLibraries: z.array(z.string()).optional(),
  planType: z.enum(TeamPlanType),
  expiry: z.string().optional(),
  theme: ThemeGenShape.optional(),
  notificationsEnabled: z.boolean(),
  ssoEnforced: z.boolean(),
  jitProvisioningEnabled: z.boolean(),
  ssoEnabledAt: z.string().optional(),
  oidcSsoConfig: OidcSsoConfigGenShape.optional(),
  id: z.string(),
});
